const styles = theme => ({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    background: 'rgba(64, 64, 64, 0.5)',
    zIndex: 1000,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    padding: 20,
    background: '#fff',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  btnOutline: theme.btnOutline,
});

export default styles;
